import {
  GAME_ID,
  REDUX_ACTIONS,
} from '../../data/planTorresConstants';

const initialState = {
  // props synchronized with server
  highestLevelEarned: 0,
  gameDetails: {
    // object with toppers earned by user: levelId => topperId
    toppers: {},
    // true, if user already completed first time onboarding
    isOnboardingCompleted: false,
  },
  // local props
  isToppersQuestResetDone: false,
};

const planTorresGameDetailsReducer = (state = initialState, { gameId, type, payload = {} }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.UPDATE_GAME_PRACTICE_DETAILS: {
      const { highestLevelEarned, toppers, isMastered } = payload;

      return {
        ...state,
        highestLevelEarned,
        isMastered,
        gameDetails: {
          ...state.gameDetails,
          toppers,
        },
      };
    }
    case REDUX_ACTIONS.UPDATE_GAME_ONBOARDING_DETAILS: {
      return {
        ...state,
        gameDetails: {
          ...state.gameDetails,
          isOnboardingCompleted: true,
        },
      };
    }
    case REDUX_ACTIONS.RESET_GAME_TOPPERS_DETAILS_FOR_QUEST: {
      return {
        ...state,
        gameDetails: {
          ...state.gameDetails,
          toppers: {},
        },
        isToppersQuestResetDone: true,
      };
    }
    default:
      return state;
  }
};

export default planTorresGameDetailsReducer;
